import { useEffect } from "react";
import { useSite } from "@/context/SiteContext";
import { mediaUrl } from "@/lib/api";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content || "");
};

export const useSeo = ({ title, description, image } = {}) => {
  const { settings } = useSite();
  useEffect(() => {
    const brand = settings?.brand_name || "Own Brand Technologies";
    const t = title ? (title.includes(brand) ? title : `${title} | ${brand}`) : settings?.seo_title || brand;
    const d = description || settings?.seo_description || "";
    const img = mediaUrl(image || settings?.og_image || "");
    document.title = t;
    setMeta("name", "description", d);
    setMeta("property", "og:title", t);
    setMeta("property", "og:description", d);
    setMeta("property", "og:url", window.location.href);
    setMeta("property", "og:site_name", brand);
    if (img) setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = `${(settings?.website_url || window.location.origin).replace(/\/$/, "")}${window.location.pathname}`;
  }, [title, description, image, settings]);
};
